import { render, staticRenderFns } from "./PaginationModalLayout.vue?vue&type=template&id=ca896e4e&scoped=true"
import script from "./PaginationModalLayout.vue?vue&type=script&lang=js"
export * from "./PaginationModalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca896e4e",
  null
  
)

export default component.exports